import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { Row, Col } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import FilterPanel from '../../components/common/filterPanel';
import { getCertFilterSectionData, searchCertificates, searchCertificatesCount, } from '../../services/certificateService';
import CertificateDataTable from '../../components/certificate/certificateDataTable';
import { convertSelFilterValToLuObj, convertSelFilterValBusinessToLuObj, formatDate, decryptURL, } from '../../utils/commonUtil';
import { useDispatch, useSelector } from 'react-redux';
import { setKeywordSearchStr } from '../../context/reducers/userReducer';
import FloatingOptions from "../../components/common/floatingOptions";
import commonService from "../../services/CommonService";
import { UserActivity } from "../../config/BVConstants";
export const Certificates = () => {
    var _a, _b, _c, _d, _e;
    const [certId, setCertId] = useState();
    const [selCertStatus, setSelCertStatus] = useState([]);
    const [selBrandList, setSelBrandList] = useState([]);
    const [selCountryTerritoryList, setSelCountryTerritoryList] = useState([]);
    const [selProductTypeList, setSelProductTypeList] = useState([]);
    const [selServiceTypeList, setSelServiceTypeList] = useState([]);
    const [selLstBVLocation, setSelLstBVLocation] = useState([]);
    const [selCertRenewStatusList, setSelCertRenewStatusList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const location = useLocation();
    const { strProjectId } = location.state || {};
    const [keyValue, setKeyValue] = useState(((_a = location.state) === null || _a === void 0 ? void 0 : _a.keyValue) || null);
    const [selIssueDateRange, setSelIssueDateRange] = useState([undefined, undefined]);
    const [selExpDateRange, setSelExpDateRange] = useState([undefined, undefined]);
    const [selRenDecisionDtRange, setSelRenDecisionDtRange] = useState([undefined, undefined]);
    const [certDataList, setCertDataList] = useState();
    const [strUserSearchBoxText, setStrUserSearchBoxText] = useState();
    const [primaryModel, setPrimaryModel] = useState();
    const applicationData = useSelector((state) => state.applicationData);
    const dispatch = useDispatch();
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0
    });
    const [searchCertRequest, setSearchCertRequest] = useState();
    const [selIntValidityOptionType, setSelIntValidityOptionType] = useState();
    const [selIntExpiryCountId, setSelIntExpiryCountId] = useState();
    const [selIntRenewalCountId, setSelIntRenewalCountId] = useState();
    const [key, setKey] = useState(0);
    const [width, setWidth] = useState(window.innerWidth);
    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }
    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        };
    }, []);
    const [params, setParams] = useState(null);
    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
        const queryParams = {
            Key: searchParams.get('key') || '',
            B: searchParams.get('b') || '',
            R: searchParams.get('r') || '',
            M: searchParams.get('m') || '',
            C: searchParams.get('c') || '',
            Q: searchParams.get('q') || '',
            CT: searchParams.get('ct') || '',
            RID: searchParams.get('rid') || '',
        };
        setParams(queryParams);
    }, []);
    const boolScreenAccessCheck = ((_e = (_d = (_c = (_b = applicationData === null || applicationData === void 0 ? void 0 : applicationData.getClientUserScreenAccess) === null || _b === void 0 ? void 0 : _b.lstClientUserCompanies) === null || _c === void 0 ? void 0 : _c.find((obj) => { var _a, _b; return obj.intId === ((_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.intCompanyID); })) === null || _d === void 0 ? void 0 : _d.lstObjLuScreens) === null || _e === void 0 ? void 0 : _e.find((obj) => obj.intId === 3)) != undefined;
    const navigate = useNavigate();
    useEffect(() => {
        var _a, _b, _c, _d, _e;
        if (!((_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.subscriptionDetails) === null || _a === void 0 ? void 0 : _a.boolCertificateSearchPage) || !boolScreenAccessCheck) {
            navigate('/no-access');
            return;
        }
        else if ((_c = (_b = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _b === void 0 ? void 0 : _b.userLoginDetails) === null || _c === void 0 ? void 0 : _c.strUserEmailId) {
            commonService
                .logUserActivity((_e = (_d = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _d === void 0 ? void 0 : _d.userLoginDetails) === null || _e === void 0 ? void 0 : _e.strUserEmailId, UserActivity.CP__CertMgmt_Visited);
        }
        if (!params)
            return;
        setCertDataList([]);
        setIsLoading(true);
        const boolValues = {
            boolOpenEndedCertificate: false,
            boolLimitedValidity: false,
            boolExpiredCertificate: false,
            boolCancelledCertificate: false,
        };
        selCertStatus.forEach((status) => {
            if (status === '1')
                boolValues.boolOpenEndedCertificate = true;
            if (status === '2')
                boolValues.boolLimitedValidity = true;
            if (status === '3')
                boolValues.boolExpiredCertificate = true;
            if (status === '4')
                boolValues.boolCancelledCertificate = true;
        });
        const IssueFromDate = selIssueDateRange[0] ? selIssueDateRange[0].format('YYYY-MM-DD') : null;
        const issueToDate = selIssueDateRange[1] ? selIssueDateRange[1].format('YYYY-MM-DD') : null;
        const expFromDate = selExpDateRange[0] ? selExpDateRange[0].format('YYYY-MM-DD') : null;
        const expToDate = selExpDateRange[1] ? selExpDateRange[1].format('YYYY-MM-DD') : null;
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const showLinkParam = urlParams.get('show-link');
        const certNotifyEmail = urlParams.get('k');
        const strRegLibId = urlParams.get('rid') ? atob(urlParams.get('rid')) : '';
        const nCode = urlParams.get('n_code');
        if (nCode) {
            setKeyValue(nCode);
        }
        const boolGetExpCertDetails = keyValue === 'EXPSIXMONTH' || null;
        const boolRenewalOverdueReq = keyValue === 'RENEWALOVERDUE' || null;
        const boolsearchBasedOnReq = keyValue === 'CERTWITHUPDREQ' || null;
        let boolsearchBasedOnReg = urlParams.get('rid') ? true : keyValue === 'CERTWITHUPDREG';
        var boolNotificationCertExpMonth;
        var dtCertNotifyCurrent;
        var intNotifyMonth;
        var boolNotificationCertExpWeek;
        var boolNotificationRegUpdate;
        var lstLuRenewalStatus = [];
        if (certNotifyEmail) {
            const decryptedString = decryptURL(certNotifyEmail);
            const arrParam = decryptedString.split(",");
            if (arrParam[3] !== null && arrParam[3] !== "" && arrParam[3] === "CEM") {
                boolNotificationCertExpMonth = true;
                dtCertNotifyCurrent = formatDate(arrParam[4]); // assuming arrParam[4] is a valid date string
                intNotifyMonth = parseInt(arrParam[5]);
                const intRenewalType = parseInt(arrParam[6]);
                if (intRenewalType !== null && intRenewalType === 1) {
                    lstLuRenewalStatus.push({ intId: 6010 });
                }
            }
            if (arrParam[3] !== null && arrParam[3] !== "" && arrParam[3] === "CEW") {
                boolNotificationCertExpWeek = true;
                dtCertNotifyCurrent = formatDate(arrParam[4]); // assuming arrParam[4] is a valid date string
            }
            if (arrParam[3] !== null && arrParam[3] !== "" && arrParam[3] === "RU") {
                boolNotificationRegUpdate = true;
                const intRenewalType = parseInt(arrParam[4]);
                if (intRenewalType !== null && intRenewalType === 1) {
                    lstLuRenewalStatus.push({ intId: 6010 });
                }
            }
        }
        let decodedId = null;
        if (showLinkParam)
            decodedId = showLinkParam ? atob(showLinkParam) : null;
        decodedId = decodedId === null || decodedId === void 0 ? void 0 : decodedId.split('-')[0];
        const firstPage = pagination.current == 1 ? pagination.current : ((pagination.current * 10) - 10) + 1;
        const lastPage = pagination.current == 1 ? pagination.pageSize : (pagination.current * 10);
        const searchCertReqObj = {
            strProjectId: strProjectId,
            lstLuCompany: applicationData === null || applicationData === void 0 ? void 0 : applicationData.selClientList,
            lstSelCertStatus: convertSelFilterValToLuObj(selCertStatus),
            lstCountries: convertSelFilterValToLuObj(selCountryTerritoryList).length == 0 && (params.C === '' || params.C === null)
                ? null
                : convertSelFilterValToLuObj(selCountryTerritoryList).length == 0
                    ? [{ intId: Number(params.C) }]
                    : convertSelFilterValToLuObj(selCountryTerritoryList),
            lstProductType: convertSelFilterValToLuObj(selProductTypeList),
            lstServiceType: convertSelFilterValToLuObj(selServiceTypeList),
            lstBrandNames: convertSelFilterValToLuObj(selBrandList),
            strCertId: certId,
            //lstLuRenewalStatus: convertSelFilterValToLuObj(selCertRenewStatusList),
            lstLuRenewalStatus: convertSelFilterValToLuObj(selCertRenewStatusList).length === 0 && (params.R === '' || params.R === null) && lstLuRenewalStatus.length === 0
                ? null
                : convertSelFilterValToLuObj(selCertRenewStatusList).length != 0 ? convertSelFilterValToLuObj(selCertRenewStatusList) :
                    (params.R != '' || params.R != null) ? [{ intId: Number(params.R) }] : lstLuRenewalStatus.length != 0 ? lstLuRenewalStatus : null,
            lstobjBusinessUnit: convertSelFilterValBusinessToLuObj(selLstBVLocation),
            boolOpenEndedCertificate: boolValues.boolOpenEndedCertificate,
            boolLimitedValidity: boolValues.boolLimitedValidity,
            boolExpiredCertificate: boolValues.boolExpiredCertificate,
            boolCancelledCertificate: boolValues.boolCancelledCertificate,
            boolSearchSuggetionFlag: true,
            strSearchBoxText: strUserSearchBoxText,
            lstCertStatus: convertSelFilterValToLuObj(selCertStatus),
            dtCertificationFrom: formatDate(IssueFromDate),
            dtCertificationTo: formatDate(issueToDate),
            dtCertExpFrom: formatDate(expFromDate),
            dtCertExpTo: formatDate(expToDate),
            strModelName: primaryModel == '' || primaryModel == null ? (params.M != '' && params.Key != '' ? params.M : null) : primaryModel,
            boolGetExpCertDetails: boolGetExpCertDetails,
            boolRenewalOverdueReq: boolRenewalOverdueReq,
            boolsearchBasedOnReg: boolsearchBasedOnReg,
            boolsearchBasedOnReq: boolsearchBasedOnReq,
            strRegulationId: decodedId,
            intValidityOptionType: params.Q != '' && params.Key != '' ? Number(params.Q) : null,
            intRenewalCountId: params.Q != '' && params.Q == '1' && params.Key != '' ? Number(params.Key) : null,
            intExpiryCountId: params.Q != '' && params.Q == '2' && params.Key != '' ? Number(params.Key) : null,
            intRenewalUnDecided: params.CT != '' && params.Key != '' && params.Q == '1' ? Number(params.CT) : null,
            objLuBrandName: (params.B !== '' && params.Key !== '')
                ? { intId: params.B !== '' ? Number(params.B) : null } : null,
            boolNotificationCertExpMonth: boolNotificationCertExpMonth,
            dtCertNotifyCurrent: dtCertNotifyCurrent,
            intNotifyMonth: intNotifyMonth,
            boolNotificationCertExpWeek: boolNotificationCertExpWeek,
            boolNotificationRegUpdate: boolNotificationRegUpdate,
            strRegLibId: strRegLibId,
            intPageSize: lastPage,
            intFirstPage: firstPage,
        };
        setIsLoading(true);
        searchCertificatesCount(searchCertReqObj).then((res) => {
            setPagination(prev => (Object.assign(Object.assign({}, prev), { total: res })));
        });
        searchCertificates(searchCertReqObj).then((res) => {
            var _a, _b;
            setCertDataList(res);
            setSearchCertRequest(searchCertReqObj);
            setIsLoading(false);
            commonService
                .logUserActivity((_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.strUserEmailId, UserActivity.CP__CertMgmt_Search);
        });
    }, [
        selCertStatus,
        selBrandList,
        selCountryTerritoryList,
        selProductTypeList,
        selServiceTypeList,
        selLstBVLocation,
        selCertRenewStatusList,
        selIssueDateRange,
        selExpDateRange,
        selRenDecisionDtRange,
        primaryModel,
        keyValue,
        strUserSearchBoxText,
        pagination.current,
        pagination.pageSize,
        params,
        key
        // selIntValidityOptionType,
        // selIntExpiryCountId,
        // selIntRenewalCountId
    ]);
    const isInitialRender = useRef(true);
    const [shouldExecuteEffect, setShouldExecuteEffect] = useState(false);
    useEffect(() => {
        if (isInitialRender.current) {
            // Skip the first run
            isInitialRender.current = false;
            return;
        }
        if (selIntExpiryCountId === undefined) {
            return; // Skip if not triggered by child action
        }
        let renCode = null;
        let exCode = null;
        if (selIntValidityOptionType === 1) {
            if (selIntExpiryCountId === 270)
                renCode = 170;
            if (selIntExpiryCountId === 265)
                renCode = 165;
            if (selIntExpiryCountId === 260)
                renCode = 160;
            if (selIntExpiryCountId === 250)
                renCode = 150;
            if (selIntExpiryCountId === 240)
                renCode = 140;
            if (selIntExpiryCountId === 230)
                renCode = 130;
            if (selIntExpiryCountId === 220)
                renCode = 120;
            if (selIntExpiryCountId === 290)
                renCode = 190;
        }
        else {
            exCode = selIntExpiryCountId;
        }
        const firstPage = pagination.current == 1 ? pagination.current : ((pagination.current * 10) - 10) + 1;
        const lastPage = pagination.current == 1 ? pagination.pageSize : (pagination.current * 10);
        const searchCertReqObj = {
            boolSearchSuggetionFlag: true,
            lstLuCompany: applicationData === null || applicationData === void 0 ? void 0 : applicationData.selClientList,
            strSearchBoxText: "",
            intPageSize: lastPage,
            intFirstPage: firstPage,
            intValidityOptionType: selIntValidityOptionType,
            intRenewalCountId: renCode,
            intExpiryCountId: exCode
        };
        setIsLoading(true);
        searchCertificatesCount(searchCertReqObj).then((res) => {
            setPagination(prev => (Object.assign(Object.assign({}, prev), { total: res })));
        });
        searchCertificates(searchCertReqObj).then((res) => {
            var _a, _b;
            setCertDataList(res);
            setSearchCertRequest(searchCertReqObj);
            setIsLoading(false);
            commonService
                .logUserActivity((_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.strUserEmailId, UserActivity.CP__CertMgmt_Search);
        });
    }, [
        selIntValidityOptionType,
        selIntExpiryCountId,
        selIntRenewalCountId,
        shouldExecuteEffect
    ]);
    const handleChildClick = () => {
        setShouldExecuteEffect(true); // Trigger the effect when the child is clicked
    };
    useEffect(() => {
        if (applicationData.keywordSearchStr) {
            setKeyValue(null);
            setStrUserSearchBoxText(applicationData.keywordSearchStr);
            dispatch(setKeywordSearchStr(''));
        }
    }, [applicationData.keywordSearchStr]);
    const reLoadData = () => {
        setKey(prevKey => prevKey + 1);
        setPagination(prev => (Object.assign(Object.assign({}, prev), { current: 1 })));
    };
    useEffect(() => {
        if (strUserSearchBoxText) {
            if (strUserSearchBoxText.includes('Primary Model - ')) {
                setPrimaryModel(strUserSearchBoxText.split('Primary Model - ')[1]);
                setStrUserSearchBoxText('');
            }
            if (strUserSearchBoxText.includes('Series Model - ')) {
                setPrimaryModel(strUserSearchBoxText.split('Series Model - ')[1]);
                setStrUserSearchBoxText('');
            }
        }
    }, [strUserSearchBoxText]);
    const handleTableChange = (pagination) => {
        setPagination(prev => (Object.assign(Object.assign({}, prev), { current: pagination.current, pageSize: pagination.pageSize })));
    };
    const handleClearAllAppliedFilters = () => {
        setKeyValue(null);
        setSelCertStatus([]);
        setSelBrandList([]);
        setSelCountryTerritoryList([]);
        setSelProductTypeList([]);
        setSelServiceTypeList([]);
        setSelLstBVLocation([]);
        setSelCertRenewStatusList([]);
        setSelIssueDateRange([undefined, undefined]);
        setSelExpDateRange([undefined, undefined]);
        setSelRenDecisionDtRange([undefined, undefined]);
        setStrUserSearchBoxText('');
        setPagination(prev => (Object.assign(Object.assign({}, prev), { current: 1 })));
        setSelIntValidityOptionType(null);
        setSelIntExpiryCountId(null);
        setSelIntRenewalCountId(null);
    };
    useEffect(() => {
        setPagination(prev => (Object.assign(Object.assign({}, prev), { current: 1 })));
    }, [selCertStatus,
        selBrandList,
        selLstBVLocation,
        selCountryTerritoryList,
        selProductTypeList,
        selServiceTypeList,
        selCertRenewStatusList,
        selIssueDateRange,
        selExpDateRange,
        selRenDecisionDtRange,
        // selIntValidityOptionType,
        // selIntExpiryCountId,
        // selIntRenewalCountId,
    ]);
    const certFilterSectionData = getCertFilterSectionData(applicationData, selCertStatus, (val) => setSelCertStatus(val), selBrandList, (val) => setSelBrandList(val), selLstBVLocation, (val) => setSelLstBVLocation(val), selCountryTerritoryList, (val) => setSelCountryTerritoryList(val), selProductTypeList, (val) => setSelProductTypeList(val), selServiceTypeList, (val) => setSelServiceTypeList(val), selCertRenewStatusList, (val) => setSelCertRenewStatusList(val), selIssueDateRange, (val) => setSelIssueDateRange(val), selExpDateRange, (val) => setSelExpDateRange(val), selRenDecisionDtRange, (val) => setSelRenDecisionDtRange(val), selIntValidityOptionType, (val) => setSelIntValidityOptionType(val), selIntExpiryCountId, (val) => setSelIntExpiryCountId(val), selIntRenewalCountId, (val) => setSelIntRenewalCountId(val), handleClearAllAppliedFilters);
    return (_jsxs(_Fragment, { children: [width <= 1150 &&
                _jsx(FloatingOptions, { data: certFilterSectionData, onClickFun: handleChildClick }), _jsxs(Row, { gutter: [16, 16], children: [width > 1150 &&
                        _jsx(Col, { xs: 24, sm: 24, md: 24, lg: 6, xl: 5, children: _jsx(FilterPanel, { data: certFilterSectionData, onClickFun: handleChildClick }) }), _jsx(Col, { xs: 24, sm: 24, md: 24, lg: (width <= 1150) ? 24 : 18, xl: (width <= 1150) ? 24 : 19, children: _jsx(CertificateDataTable, { reLoadData: reLoadData, data: certDataList, searchCertRequest: searchCertRequest, loading: isLoading, pagination: pagination, onChange: handleTableChange }) })] })] }));
};
export default Certificates;
